//import logo from './logo.svg';
//import './App.css';
import Router from './routes'
import ThemeProvider from './theme';
import { MotionLazyContainer } from './components/animate';
import SnackbarProvider from './components/snackbar';

function App() {
  return (
    <> 
      <MotionLazyContainer>
        <ThemeProvider>
          <SnackbarProvider>
            <Router />
          </SnackbarProvider>
        </ThemeProvider>
      </MotionLazyContainer>
    </>
  );
}

export default App;
